import { tags as en_tags } from "../en/tags";

/** tags — es slice. */
export const tags: Record<keyof typeof en_tags, string> = {
  // --- Profile tags ---
  tag_90s_kid: "Niño de los 90",
  tag_restaurants: "Restaurantes",
  tag_music: "Música",
  tag_self_care: "Autocuidado",
  tag_concerts: "Conciertos",
  tag_house_parties: "Fiestas en casa",
  tag_drinks: "Bebidas",
  tag_athletics: "Atletismo",
  tag_religious: "Religioso",
  tag_sports: "Deportes",
  tag_meditation: "Meditación",
  tag_night_life: "Vida nocturna",
  tag_books: "Libros",
  tag_cafes: "Cafeterías",
  tag_raves: "Raves",
  tag_clubs: "Clubes",
  tag_traveling: "Viajar",
  tag_business: "Negocios",
  tag_sneakers: "Zapatillas",
  tag_instagram: "Instagram",
  tag_nature: "Naturaleza",
  tag_introvert: "Introvertido",
  tag_extrovert: "Extrovertido",
  tag_minimalist: "Minimalista",
  tag_astrology: "Astrología",
  tag_fashion: "Moda",
  tag_tattoos: "Tatuajes",
  tag_thrifting: "Ropa de segunda mano",
  tag_plant_parent: "Amante de las plantas",
  tag_dog_lover: "Amante de los perros",
  tag_cat_lover: "Amante de los gatos",
  tag_volunteering: "Voluntariado",
  tag_sustainability: "Sostenibilidad",
  tag_skincare: "Cuidado de la piel",
  tag_journaling: "Escribir un diario",
  tag_spirituality: "Espiritualidad",
  tag_vintage: "Vintage",
  tag_diy: "Hazlo tú mismo",
  tag_entrepreneurship: "Emprendimiento",
  tag_side_hustles: "Trabajos secundarios",
  tag_cooking: "Cocinar",
  tag_baking: "Repostería",
  tag_coffee: "Café",
  tag_wine: "Vino",
  tag_craft_beer: "Cerveza artesanal",
  tag_cocktails: "Cócteles",
  tag_vegan: "Vegano",
  tag_foodie: "Amante de la comida",
  tag_brunch: "Brunch",
  tag_street_food: "Comida callejera",
  tag_sushi: "Sushi",
  tag_bbq: "Barbacoa",
  tag_tea: "Té",
  tag_photography: "Fotografía",
  tag_art: "Arte",
  tag_museums: "Museos",
  tag_theater: "Teatro",
  tag_poetry: "Poesía",
  tag_film: "Cine",
  tag_anime: "Anime",
  tag_k_pop: "K-Pop",
  tag_hip_hop: "Hip Hop",
  tag_jazz: "Jazz",
  tag_edm: "EDM",
  tag_r_b: "R&B",
  tag_podcasts: "Podcasts",
  tag_stand_up_comedy: "Comedia en vivo",
  tag_dancing: "Bailar",
  tag_writing: "Escribir",
  tag_design: "Diseño",
  tag_gym: "Gimnasio",
  tag_yoga: "Yoga",
  tag_running: "Correr",
  tag_hiking: "Senderismo",
  tag_swimming: "Natación",
  tag_cycling: "Ciclismo",
  tag_climbing: "Escalada",
  tag_surfing: "Surf",
  tag_skiing: "Esquí",
  tag_camping: "Acampar",
  tag_crossfit: "CrossFit",
  tag_martial_arts: "Artes marciales",
  tag_tennis: "Tenis",
  tag_basketball: "Baloncesto",
  tag_soccer: "Fútbol",
  tag_skateboarding: "Skateboarding",
  tag_tech: "Tecnología",
  tag_gaming: "Videojuegos",
  tag_coding: "Programación",
  tag_startups: "Startups",
  tag_investing: "Inversión",
  tag_crypto: "Cripto",
  tag_ai: "IA",
  tag_science: "Ciencia",
  tag_languages: "Idiomas",
  tag_psychology: "Psicología",
  tag_philosophy: "Filosofía",
  tag_history: "Historia",
  tag_board_games: "Juegos de mesa",
  tag_trivia: "Trivia",
  tag_karaoke: "Karaoke",
  tag_road_trips: "Viajes por carretera",
  tag_festivals: "Festivales",
  tag_picnics: "Picnics",
  tag_beach: "Playa",
  tag_netflix: "Netflix",
  tag_true_crime: "Crímenes reales",
  tag_memes: "Memes",
  tag_tiktok: "TikTok",
  tag_youtube: "YouTube",

  // --- Company-only tags ---
  tag_food: "Comida",
  tag_concert: "Concierto",
  tag_outdoor_events: "Eventos al aire libre",
  tag_tour: "Tour",
  tag_lounge: "Lounge",
  tag_day_night_club: "Club de día/noche",
  tag_sporting_event: "Evento deportivo",
  tag_social_club: "Club social",
  tag_sports_exercise: "Deportes / Ejercicio",
  tag_bar: "Bar",
  tag_nightclub: "Discoteca",
  tag_cafe: "Café",
  tag_brewery: "Cervecería",
  tag_winery: "Bodega",
  tag_event_space: "Espacio para eventos",
  tag_entertainment_venue: "Local de entretenimiento",
  tag_other: "Otro",
  // --- Interest category section headers (#49) ---
  tag_category_popular: "Popular",
  tag_category_lifestyle: "Estilo de vida y personalidad",
  tag_category_food_drink: "Comida y bebida",
  tag_category_arts_culture: "Arte y cultura",
  tag_category_fitness_outdoors: "Fitness y aire libre",
  tag_category_tech_learning: "Tecnología y aprendizaje",
  tag_category_social_entertainment: "Social y entretenimiento",
  tag_category_other: "Más",
};
